import {
  applyThemeBuilderColors,
  hasThemeBuilderPreferences,
  readThemeBuilderStorage,
  sanitizeThemeBuilderStorage,
  writeThemeBuilderStorage,
} from './themeBuilder.js'
import {
  readServerChartPreference,
  writeServerChartPreference,
} from './chart/chartPreferenceStore.js'

export const THEME_PREFERENCE_SCOPE = 'app-theme'
export const THEME_PREFERENCE_KEY = 'theme-builder'

export async function readServerThemeBuilderStorage({ userId = null } = {}) {
  const preferences = await readServerChartPreference({
    scope: THEME_PREFERENCE_SCOPE,
    preferenceKey: THEME_PREFERENCE_KEY,
    userId,
  })

  return preferences ? sanitizeThemeBuilderStorage(preferences) : null
}

export async function writeServerThemeBuilderStorage({ storage, userId = null } = {}) {
  const preferences = sanitizeThemeBuilderStorage(storage)
  return writeServerChartPreference({
    scope: THEME_PREFERENCE_SCOPE,
    preferenceKey: THEME_PREFERENCE_KEY,
    preferences,
    userId,
  })
}

export async function persistThemeBuilderStorage({ userId = null } = {}) {
  return writeServerThemeBuilderStorage({
    storage: readThemeBuilderStorage(),
    userId,
  })
}

export async function hydrateThemeBuilderStorageFromServer({ userId = null } = {}) {
  const serverStorage = await readServerThemeBuilderStorage({ userId })

  if (serverStorage) {
    writeThemeBuilderStorage(serverStorage)
    applyThemeBuilderColors()
    return { source: 'server', storage: serverStorage }
  }

  const localStorageState = readThemeBuilderStorage()
  if (hasThemeBuilderPreferences(localStorageState)) {
    await writeServerThemeBuilderStorage({ storage: localStorageState, userId })
  }

  return { source: 'local', storage: localStorageState }
}
